/**
 * Action Types & Action Creators for Updating Predictions
 *
 * This module provides the action types and action creators related to
 * updating the predictions in the Redux store.
 */

// Action Type: Represents the action to update predictions in the store.
export const UPDATE_PREDICTIONS = "UPDATE_PREDICTIONS";

/**
 * Action Creator: updatePredictions
 *
 * Generates an action to update predictions with the provided payload.
 *
 * @param {Object} payload - The data that needs to be updated in the predictions.
 * @returns {Object} - Action object with type `UPDATE_PREDICTIONS` and the provided payload.
 */
export const updatePredictions = (payload) => {
  return {
    type: UPDATE_PREDICTIONS,
    payload: payload,
  };
};
